import script from "./PageReload.vue?vue&type=script&lang=js"
export * from "./PageReload.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__